import { FormikDateTimePicker } from "../../../components/FormikFields/FormikDateTimePicker.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Events/components/EventDateTimeField.tsx
var EventDateTimeField = ({}) => {
	return /* @__PURE__ */ jsx(FormikDateTimePicker, {
		label: "Date & Time",
		name: "date"
	});
};
//#endregion
export { EventDateTimeField };

//# sourceMappingURL=EventDateTimeField.js.map